import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  Button,
  InputLabel,
  FormControl,
  Popover,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import sampleImage from '../../../../assets/error.png'
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile, toBlobURL } from '@ffmpeg/util';
import VideoCreationDialogForVeo from "./VideoCreationDialogForVeo";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";
import CommonToast from "../../../Common_Components/CommonToast";

  const positionOptions = [
    { value: 'top-left', label: 'Top Left' },
    { value: 'top-right', label: 'Top Right' },
    { value: 'bottom-left', label: 'Bottom Left' },
    { value: 'bottom-right', label: 'Bottom Right' },
    { value: 'center', label: 'Center' }
  ];

const Watermark = ({selectedWaterMarkType ,activeVideo, veo2Videos  }) => {
  const [text, setText] = useState("Sample Text");
  const [fontSize, setFontSize] = useState(20);
  const [color, setColor] = useState("#ffffff");
  const [transparency, setTransparency] = useState(100);
  const [watermarkImage, setWatermarkImage] = useState(null);
  const [ffmpegLoading, setFfmpegLoading] = useState(false);
  const [selectedWaterMarkPosition, setSelectedWaterMarkPosition] = useState('center');
  const [error, setError] = useState('');
  const imageInputRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [opacity, setOpacity] = useState(0.7);
  const [activeVideoObject, setActiveVideoObject] = useState()
  const {setVeo2Videos} = useWorkspace()
  const open = Boolean(anchorEl);
  const [watermarkOptions, setWatermarkOptions] = useState({
    position: selectedWaterMarkPosition,
    opacity: 0.7,
    sizeType: "scale", // 'scale', 'absolute', 'percentage'
    width: 2,        // pixels
    height: 2,        // pixels
    scale: 0.03,      // Reduced from 0.20 to 0.08 (8% instead of 20%)
    percentage: 8     // percentage of video size
  });
  const videoRef = useRef(null);
  const ffmpegRef = useRef(null);
  const ffmpegLoadedRef = useRef(false);
  const [openAlert, setOpen] = useState(false)
  const [content, setContent] = useState();
  const [iconType, setIconType] = useState('success');

   const handleCloseToast = () => {
    setOpen(false);
  };

  useEffect(()=>{
    setActiveVideoObject(veo2Videos[activeVideo])
  },[])

  // Update position when selectedWaterMarkPosition changes
useEffect(() => {
  setWatermarkOptions(prev => ({
    ...prev,
    position: selectedWaterMarkPosition,
  }));
}, [selectedWaterMarkPosition]); // This ensures sync between states

  // Mock video source - replace with your actual video URL
  const videoSrc =  veo2Videos[activeVideo].url || 'https://uploads.dev.modalx.ai/output/files/9e0b62e8-7aae-4f03-a40f-6c90bad04856.mp4';
    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // console.log("activeVideo", activeVideo)
    // console.log("activeVideoObject", activeVideoObject)



  // const handleFileUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const imageUrl = URL.createObjectURL(file);
  //     setUploadedImage(imageUrl);
  //   }
  // };

  // const handleUrlSubmit = () => {
  //   if (imageUrl) {
  //     setUploadedImage(imageUrl);
  //   }
  // };

  // const handleSave = () => {
  //   // Handle save functionality here
  //   console.log('Saving image with:', {
  //     backgroundColor,
  //     transparency,
  //     image: uploadedImage
  //   });
  // };

  const handleImageSelect = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setWatermarkImage(file);
    } else {
      // alert('Please select a valid image file');
      setOpen(true);
      setIconType('error')
      setContent('Please select a valid image file')
    }
  };

const addTextWatermarkToVideo = async (
  videoUrl,
  text,
  options = {},
  onProgress
) => {
  const {
    position = "center",
    fontSize = 24,
    fontColor = "white",
    opacity = 1.0,
    fontFile = "Arial" // You might need to provide a font file
  } = options;

  setFfmpegLoading(true);
  
  try {
    const ff = await loadFFmpeg();
    
    ff.on("progress", ({ progress }) => {
      if (onProgress) onProgress(Math.min(progress * 100, 100));
    });

    await ff.writeFile("input.mp4", await fetchFile(videoUrl));

    // Generate drawtext filter
    const textFilter = generateTextWatermarkFilter(text, position, fontSize, fontColor, opacity);

    console.log("Using text filter:", textFilter);

    const command = [
      "-i", "input.mp4",
      "-vf", textFilter,
      "-c:v", "libx264",
      "-preset", "medium",
      "-crf", "23",
      "-movflags", "+faststart",
      "-y",
      "output.mp4"
    ];

    await ff.exec(command);

    const data = await ff.readFile("output.mp4");
    const watermarkedBlob = new Blob([data], { type: "video/mp4" });
    
    return watermarkedBlob;
    
  } catch (error) {
    console.error("Failed to add text watermark:", error);
    throw error;
  } finally {
    setFfmpegLoading(false);
  }
};

const generateTextWatermarkFilter = (text, position, fontSize, fontColor, opacity) => {
  const alpha = Math.max(0, Math.min(1, opacity));
  
  let positionParams = '';
  switch (position) {
    case "top-left":
      positionParams = `x=10:y=10`;
      break;
    case "top-right":
      positionParams = `x=w-tw-10:y=10`;
      break;
    case "bottom-left":
      positionParams = `x=10:y=h-th-10`;
      break;
    case "bottom-right":
      positionParams = `x=w-tw-10:y=h-th-10`;
      break;
    case "center":
    default:
      positionParams = `x=(w-tw)/2:y=(h-th)/2`;
      break;
  }

  // Escape text for FFmpeg
  const escapedText = text.replace(/'/g, "'\\\\\\''");
  
  return `drawtext=text='${escapedText}':fontsize=${fontSize}:fontcolor=${fontColor}@${alpha}:${positionParams}`;
};

const loadFFmpeg = async () => {
  if (ffmpegLoadedRef.current && ffmpegRef.current) {
    return ffmpegRef.current;
  }

  const ffmpeg = new FFmpeg();
  
  // Minimal logging for performance
  ffmpeg.on("log", ({ type, message }) => {
    if (type === "error") console.error(`[ffmpeg] ${message}`);
  });

  const baseURL = "https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd";

  try {
    await ffmpeg.load({
      coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, "text/javascript"),
      wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, "application/wasm"),
    });

    ffmpegRef.current = ffmpeg;
    ffmpegLoadedRef.current = true;
    return ffmpeg;
  } catch (error) {
    console.error("Failed to load FFmpeg:", error);
    throw error;
  }
};

// const loadFFmpeg = async () => {
//   if (ffmpegLoaded && ffmpeg) return ffmpeg;

//   // Initialize FFmpeg
//   ffmpeg = new FFmpeg();
  
//   // Set logger - this should work with the newer version
//   ffmpeg.on('log', ({ type, message }) => {
//     console.log(`[ffmpeg ${type}] ${message}`);
//   });

//   // Progress handling
//   ffmpeg.on('progress', ({ progress, time }) => {
//     console.log(`Progress: ${Math.round(progress * 100)}%`);
//   });

//   const baseURL = "https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd";

//   try {
//     await ffmpeg.load({
//       coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, "text/javascript"),
//       wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, "application/wasm"),
//     });

//     ffmpegLoaded = true;
//     console.log("FFmpeg loaded successfully");
//     return ffmpeg;
//   } catch (error) {
//     console.error("Failed to load FFmpeg:", error);
//     throw error;
//   }
// };

 // Convert blob URL to File object
const blobUrlToFile = async (blobUrl) => {
  try {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    const file = new File([blob], `watermark-${Date.now()}.png`, { type: blob.type });
    return file;
  } catch (error) {
    console.error('Error converting blob URL to file:', error);
    throw error;
  }
};

// Check if input is a File object
const isFile = (input) => {
  return input instanceof File;
};

// Check if input is a blob URL
const isBlobUrl = (url) => {
  return typeof url === 'string' && url.startsWith('blob:');
};

//  const addWatermarkToVideo = async (videoInput, imageInput, options = {} , onProgress) => {
//   setFfmpegLoading(true);

//     const {
//     position = "center", // Default fallback
//     opacity = 1.0,
//     width = null,
//     height = null,
//     scale= 0.03,
//     sizeType = "scale"
//   } = options;
  
//   try {
//     const ff = await loadFFmpeg();
    
//     ff.on("progress", ({ progress }) => {
//       if (onProgress) onProgress(Math.min(progress * 100, 100));
//     });

//     console.log("Processing inputs...");
    
//     // Handle video input (could be File, blob URL, or regular URL)
//     let videoFile;
//     if (isFile(videoInput)) {
//       videoFile = videoInput;
//     } else if (isBlobUrl(videoInput)) {
//       videoFile = await blobUrlToFile(videoInput);
//     } else {
//       videoFile = videoInput;
//     }
    
//     await ff.writeFile("input.mp4", await fetchFile(videoFile));
    
//     // Handle image input
//     let imageFile;
//     if (isFile(imageInput)) {
//       imageFile = imageInput;
//     } else if (isBlobUrl(imageInput)) {
//       imageFile = await blobUrlToFile(imageInput);
//     } else {
//       imageFile = imageInput;
//     }
    
//     await ff.writeFile("watermark.png", await fetchFile(imageFile));

//     // Generate overlay filter
//      // Generate overlay filter with size control
//     const overlayFilter = generateWatermarkOverlayWithSize(position, opacity, width, height, scale, sizeType);

//     console.log("Using overlay filter:", overlayFilter);
//     console.log("Position:", position); // Debug log
//     console.log("width:", width); // Debug log
//     console.log("height:", height); // Debug log
//     console.log("scale:", scale); // Debug log


//     // Build and execute FFmpeg command
//     const command = [
//       "-i", "input.mp4",
//       "-i", "watermark.png",
//       "-filter_complex", overlayFilter,
//       "-map", "[out]",
//       "-c:v", "libx264",
//       "-preset", "medium",
//       "-crf", "23",
//       "-movflags", "+faststart",
//       "-y",
//       "output.mp4"
//     ];

//     await ff.exec(command);

//     const data = await ff.readFile("output.mp4");
//     const watermarkedBlob = new Blob([data], { type: "video/mp4" });
    
//     if (watermarkedBlob.size === 0) {
//       throw new Error("Output video is empty");
//     }

//      // Create blob URL for preview
//     const watermarkedUrl = URL.createObjectURL(watermarkedBlob);
    
//      return {
//       blob: watermarkedBlob,
//       url: watermarkedUrl, // This URL can be used directly in video src
//     };
    
//   } catch (error) {
//     console.error("Failed to add watermark:", error);
//     throw error;
//   } finally {
//     setFfmpegLoading(false);
//   }
// };


const addWatermarkToVideo = async (videoInput, imageInput, options = {}, onProgress) => {
  setFfmpegLoading(true);

  const {
    position = "center",
    opacity = 1.0,
    width = null,
    height = null,
    scale = 0.03,
    sizeType = "scale"
  } = options;
  
  try {
    const ff = await loadFFmpeg();
    
    ff.on("progress", ({ progress }) => {
      if (onProgress) onProgress(Math.min(progress * 100, 100));
    });

    console.log("Processing inputs...");
    
    // Handle video input
    let videoFile;
    if (isFile(videoInput)) {
      videoFile = videoInput;
    } else if (isBlobUrl(videoInput)) {
      videoFile = await blobUrlToFile(videoInput);
    } else {
      videoFile = videoInput;
    }
    
    await ff.writeFile("input.mp4", await fetchFile(videoFile));
    
    // Handle image input
    let imageFile;
    if (isFile(imageInput)) {
      imageFile = imageInput;
    } else if (isBlobUrl(imageInput)) {
      imageFile = await blobUrlToFile(imageInput);
    } else {
      imageFile = imageInput;
    }
    
    await ff.writeFile("watermark.png", await fetchFile(imageFile));

    // Generate overlay filter
    const overlayFilter = generateWatermarkOverlayWithSize(position, opacity, width, height, scale, sizeType);

    console.log("Using overlay filter:", overlayFilter);

    // OPTIMIZED COMMAND - Much faster
    const command = [
      "-i", "input.mp4",
      "-i", "watermark.png",
      "-filter_complex", overlayFilter,
      "-map", "[out]",
      "-c:v", "libx264",
      "-preset", "veryfast", // Much faster than 'medium'
      "-crf", "28", // Higher CRF = faster encoding
      "-movflags", "+faststart",
      "-threads", "2", // Limit threads for browser
      "-x264-params", "scenecut=0:open_gop=0", // Disable CPU-intensive features
      "-y",
      "output.mp4"
    ];

    await ff.exec(command);

    const data = await ff.readFile("output.mp4");
    const watermarkedBlob = new Blob([data], { type: "video/mp4" });
    
    if (watermarkedBlob.size === 0) {
      throw new Error("Output video is empty");
    }

    const watermarkedUrl = URL.createObjectURL(watermarkedBlob);
    
    return {
      blob: watermarkedBlob,
      url: watermarkedUrl,
    };
    
  } catch (error) {
    console.error("Failed to add watermark:", error);
    throw error;
  } finally {
    setFfmpegLoading(false);
  }
};



const generateWatermarkOverlayWithSize = (position, opacity, width, height, scale, sizeType) => {
  const opacityValue = Math.max(0, Math.min(1, opacity));
  const margin = 10; // Margin from edges
  
  // Generate scale filter
  let scaleFilter = '';
  
  if (sizeType === "absolute" && (width || height)) {
    const w = width ? `:w=${width}` : '';
    const h = height ? `:h=${height}` : '';
    scaleFilter = `,scale=${w}${h}:flags=lanczos`;
  } else if (sizeType === "percentage" && scale !== 1.0) {
    scaleFilter = `,scale=iw*${scale}/100:ih*${scale}/100:flags=lanczos`;
  } else if (sizeType === "scale" && scale !== 1.0) {
    scaleFilter = `,scale=iw*${scale}:ih*${scale}:flags=lanczos`;
  }

  // Generate position filter - only 5 predefined positions
  let positionFilter = '';
  
  switch (position) {
    case "top-left":
      positionFilter = `overlay=${margin}:${margin}`;
      break;
    case "top-right":
      positionFilter = `overlay=W-w-${margin}:${margin}`;
      break;
    case "bottom-left":
      positionFilter = `overlay=${margin}:H-h-${margin}`;
      break;
    case "bottom-right":
      positionFilter = `overlay=W-w-${margin}:H-h-${margin}`;
      break;
    case "center":
    default:
      positionFilter = `overlay=(W-w)/2:(H-h)/2`;
      break;
  }

  return `[1:v]format=rgba${scaleFilter},colorchannelmixer=aa=${opacityValue}[wm];[0:v][wm]${positionFilter}[out]`;
};

// Download video function
const downloadVideo = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};


  // Basic usage
 const handleAddWatermark = async () => {
    if (!watermarkImage) {
      // alert('Please select a video and watermark image');
      setOpen(true);
    setIconType('error')
    setContent('Please select a video and watermark image')
      return;
    }

    try {
      setLoading(true);
      setProgress(0);

       // Ensure watermarkOptions has the latest position
    const currentOptions = {
      ...watermarkOptions,
      position: selectedWaterMarkPosition // Force latest position
    };
    
    // console.log("Applying watermark with options:", currentOptions); // Debug

      const watermarkResult = await addWatermarkToVideo(
        veo2Videos[activeVideo].url, // Pass the File object directly
        watermarkImage, // Pass the File object directly
        currentOptions,
        (progress) => {
          setProgress(progress);
        }
      );

      setActiveVideoObject(prevVideo=> ({
        ...prevVideo,
        url: watermarkResult.url
      }))

      // Download the result
      // downloadVideo(watermarkResult.blob, `watermarked_video_${Date.now()}.mp4`);

      // console.log("watermarkedBlob", watermarkResult)
      
      // alert('Watermark added successfully!');

    setOpen(true);
    setContent('Watermark added successfully!')
    } catch (error) {
      console.error('Watermarking failed:', error);
      // alert('Failed to add watermark: ' + (error.message || 'Unknown error'));
      setOpen(true);
      setIconType('error')
      setContent('Failed to add watermark:' + error.message)
    } finally {
      setLoading(false);
      setProgress(0);
    }
  };

  const saveWatermarkedVideo = () => {
  // Update the main videos array
  setVeo2Videos(prevVideos =>
    prevVideos.map(video =>
      video.id === activeVideoObject.id
        ? {
            ...video,
            url: activeVideoObject.url,           // updated watermarked URL for preview
            blob: activeVideoObject.blob,         // store blob for download
            watermarked: true
          }
        : video
    )
  );

  // alert("Watermark applied successfully! Preview updated.");
  setOpen(true);
  setContent("Watermark applied successfully! Preview updated.")
};

  return (
    <>
     <Box
      sx={{
        display: "flex",
        gap: 3,
      }}
    >
      {/* Left Section */}
      {
        selectedWaterMarkType?.value == "text" ? 
      <Box sx={{ flex: 1, textAlign: "center",}}>
        {/* Thumbnail Preview */}
        {/* <Box
          sx={{
            width: 250,
            height: 150,
            borderRadius: 2,
            overflow: "hidden",
            mb: 2,
            position: "relative",
          }}
        >
          <img
            src="https://images.unsplash.com/photo-1507149833265-60c372daea22"
            alt="dog"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          <Typography
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: fontSize,
              color: color,
              opacity: transparency / 100,
              fontWeight: 500,
              textShadow: "0px 2px 5px rgba(0,0,0,0.4)",
            }}
          >
            {text}
          </Typography>
        </Box> */}

        {/* Controls */}
        <Box sx={{ display: "flex", flexDirection: "column",justifyContent:"center" ,  gap: 2 }}>
          {/* Text Input */}
          <Box sx={{display:"flex", flexDirection:"row", columnGap:"12px",justifyContent:"center" , alignItems:"center"}}>
            <Typography sx={{color:"#ffffff", fontFamily:"Inter", fontSize:"16px", fontStyle:"normal", fontWeight:700, lineHeight:"20px", letterSpacing:"0.1px"}}>Add image from device</Typography>
          {/* <input
                type="file"
                ref={imageInputRef}
                accept="image/*"
                onChange={handleImageSelect}
                disabled={isProcessing}
                style={{ width: '50%' }}
              /> */}
              <Box sx={{display:"flex", flexDirection:"row", columnGap:"10px"}}>
                {/* Hidden Input */}
                <input
                  type="file"
                  ref={imageInputRef}
                  accept="image/*"
                  onChange={handleImageSelect}
                  style={{ display: "none" }}
                />

                {/* Custom Button */}
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#282D51", // custom background color
                    borderRadius:"10px",
                    color:"rgba(255, 255, 255, 0.30)",
                    border:"1px solid rgba(255, 255, 255, 0.30)",
                    "&:hover": {  bgcolor: "#282D51", border:"1px solid rgba(255, 255, 255, 0.70)" },
                  }}
                  onClick={() => imageInputRef.current.click()}
                >
                  {fileName ? `${fileName}` : "Browse"}
                </Button>

                {/* File Name Display */}
                {/* <Typography variant="body2" sx={{ mt: 1, color: "white" }}>
                  {fileName || "No file selected"}
                </Typography> */}
              </Box>
          </Box>

              {/* position */}
          <FormControl>
            <Box sx={{display:"flex", flexDirection:"row", columnGap:1.5,justifyContent:"center" ,  alignItems:"center"}}>
              <Typography sx={{color:"#ffffff", fontFamily:"Inter", fontSize:"16px", fontStyle:"normal", fontWeight:700, lineHeight:"20px", letterSpacing:"0.1px"}}>Position</Typography>
             <Button
                            onClick={handleOpen}
                            sx={{
                            color: selectedWaterMarkPosition  ? "rgba(255, 255, 255, 1)" :  "rgba(202, 196, 208, 1)",
                            backgroundColor: "#2F355F",
                            borderRadius: "8px",
                            height: "42px",
                            minWidth: "120px",
                            textTransform: "none",
                            fontFamily: "Inter",
                            fontWeight:400,
                            "&:hover": {
                                backgroundColor: "#373E6D",
                            },
                            }}
                        >
                            {selectedWaterMarkPosition || "Center"}
                            <ArrowDropDownIcon
                            sx={{ color: selectedWaterMarkPosition  ? "rgba(255, 255, 255, 1)" : "rgba(202, 196, 208, 1)", marginLeft: "auto" }}
                            />
              </Button>
            <Popover
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                            }}
                            sx={{
                            "& .MuiPaper-root": {
                                backgroundColor: "#2F355F",
                                color: "white",
                                borderRadius: "8px",
                                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                                maxHeight: "300px",
                                width: "140px",
                                marginTop: "4px",
                            },
                            }}
                        >
              <Box sx={{ overflowY: "auto", maxHeight: 250,  }}>
              {positionOptions.map((position) => (
                <MenuItem key={position} value={position} onClick={()=>{setSelectedWaterMarkPosition(position?.value); setAnchorEl(null);}}
                 sx={{
                                 color: "rgba(255, 255, 255, 1)",
                                 "&:hover": { backgroundColor: "#373E6D" },
                                 "&.Mui-selected": { backgroundColor: "#373E6D" },
                                 py: 1.5,
                                 fontSize: 14,
                                 fontFamily: 'Inter',
                    }}
                >
                  {position?.label}
                </MenuItem>
              ))}
              </Box>
            </Popover>
            </Box>
          </FormControl>

          {/* Transparency */}
          {/* <FormControl fullWidth>
            <InputLabel sx={{ color: "white" }}>Transparency</InputLabel>
            <Select
              value={transparency}
              onChange={(e) => setTransparency(e.target.value)}
              sx={{ bgcolor: "white", borderRadius: 1 }}
            >
              {[100, 90, 80, 70, 60, 50].map((val) => (
                <MenuItem key={val} value={val}>
                  {val}%
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
          <Box>
          <Button  onClick={()=>{handleAddWatermark()}} sx={{
                                 color: "rgba(255, 255, 255, 1)",
                                 "&:hover": { backgroundColor: "#373E6D" },
                                 "&.Mui-selected": { backgroundColor: "#373E6D" },
                                 py: 1.5,
                                 fontSize: 14,
                                 fontFamily: 'Inter',
                                 bgcolor:"none",
                                 padding:"10px 24px",
                                border:"1px solid rgba(255, 255, 255, 0.30)",
                                height:"40px",
                                width:"80px"
                               }}>
            Add
          </Button>
          </Box>
        </Box>
      </Box>
        :
        null
      }
  

      {/* Right Section */}
      <Box sx={{ flex: 1, borderLeft:"1px solid #ffffff", pl:3,}}>
        <Box sx={{display:"flex", flexDirection:"row", justifyContent:"space-between",alignItems:"center", mb:3,}}>

        <Typography variant="h6" sx={{color:"#ffffff", fontFamily:"Inter", fontSize:"20px", fontStyle:"normal", fontWeight:700, lineHeight:"20px", letterSpacing:"0.1px" }}>
          Preview:
        </Typography>
        <Button onClick={()=>{saveWatermarkedVideo()}}
          variant="contained"
          sx={{
            padding: "10px 24px",
            bgcolor: "#ffffff",
            color: "#242851",
            fontFamily:"Inter",
            fontWeight: 600,
            fontSize:"16px",
            fontStyle:"normal",
            lineHeight:"20px",
            letterSpacing:"0.1px",
            ":hover": { bgcolor: "#ddd" },
          }}
        >
          Save
        </Button>
        </Box>

        <Box
          sx={{
            width: 444,
            height: 250,
            borderRadius: 2,
            overflow: "hidden",
            position: "relative",
          }}
        >
          <video
          ref={videoRef}
          src={videoSrc}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            backgroundColor: '#000',
            borderRadius:"10px"
          }}
          preload="metadata"
          // onClick={togglePlayPause}
        />
          <Typography
            sx={{
              position: "absolute",
              top:
                selectedWaterMarkPosition === "top-left" || selectedWaterMarkPosition === "top-right"
                  ? 0
                  : selectedWaterMarkPosition === "bottom-left" || selectedWaterMarkPosition === "bottom-right"
                  ? "auto"
                  : "50%",
              bottom:
                selectedWaterMarkPosition === "bottom-left" || selectedWaterMarkPosition === "bottom-right"
                  ? 0
                  : "auto",
              left:
                selectedWaterMarkPosition === "top-left" || selectedWaterMarkPosition === "bottom-left"
                  ? 0
                  : selectedWaterMarkPosition === "top-right" || selectedWaterMarkPosition === "bottom-right"
                  ? "auto"
                  : "50%",
              right:
                selectedWaterMarkPosition === "top-right" || selectedWaterMarkPosition === "bottom-right"
                  ? 0
                  : "auto",
              transform: selectedWaterMarkPosition?.value === "center" ?  "translate(-50%, -50%)" : "none",
              fontSize: fontSize,
              color: color,
              opacity: transparency / 100,
              fontWeight: 600,
              textShadow: "0px 2px 6px rgba(0,0,0,0.5)",
            }}
          >
            {/* {text} */}
            <img style={{height:"20px", width:"20px"}} src={sampleImage} alt="sample"/>
          </Typography>
        </Box>

      </Box>
    </Box>
     <VideoCreationDialogForVeo open={ffmpegLoading} onClose={() => setFfmpegLoading(false)} videoTitle={"Adding WaterMark"} dailogMessage={"Adding your watermark - this will just take a moment"}/>
       <CommonToast open={open} onClose={handleCloseToast} content={content} iconType={iconType} bgColor={"#373E6D"}/>
    </>
  )
}

export default Watermark